import React, {useMemo} from 'react';
import {Outlet} from 'react-router-dom';
import {Grid, Layout} from 'antd';
import classNames from 'classnames';
import {getIsMobile} from 'helpers/utils';
import {Sidebar} from './Sidebar';
import {Topbar} from './Topbar';

export const PRMGLayout: React.FC = () => {
  const [collapsed, setCollapsed] = React.useState(false);
  const screen = Grid.useBreakpoint();

  const isMobile = useMemo(() => getIsMobile(screen), [screen]);

  return (
    <Layout className="min-h-screen h-max">
      <Topbar />
      <Layout>
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
        <Layout className={classNames('p-6', isMobile ? 'm-0' : collapsed ? 'ml-[4.5rem]' : 'ml-[13rem]')}>
          <Layout.Content className="m-0 min-h-screen bg-white rounded-lg shadow-lg p-6">
            <Outlet />
          </Layout.Content>
        </Layout>
      </Layout>
    </Layout>
  );
};
